import { Box, Text } from "@chakra-ui/react";

import AgentServiceTimePerServiceTable from "../../tables/daily/AgentServiceTimePerServiceTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { getAgentServiceTimeInsights } from "../../../../store/agentServiceTimeInsights";
import { formatTime } from "../../../../store/helpers";

const buildAgentServiceSummary = (branch) => {
  const { branchSummary, agentSummary } = getAgentServiceTimeInsights(branch);
  const topAgents = [...agentSummary]
    .filter((agent) => agent.completedTickets > 0)
    .sort((left, right) => right.completedTickets - left.completedTickets);

  return {
    kpis: [
      { label: "Completed Tickets", value: branchSummary.completedTickets.toLocaleString() },
      { label: "Total Service Time", value: formatTime(branchSummary.totalServiceTime) },
      { label: "Avg / Ticket", value: formatTime(branchSummary.averageServiceTime) },
      { label: "Active Agents", value: branchSummary.activeAgentCount.toLocaleString() },
      { label: "Flagged Agents", value: branchSummary.reviewAgentCount.toLocaleString() },
      { label: "No Completed Tickets", value: branchSummary.noWorkAgentCount.toLocaleString() },
    ],
    tables: [
      {
        title: "Agent Ranking",
        columns: [
          { id: "agentName", label: "Agent" },
          { id: "completedTickets", label: "Tickets" },
          { id: "totalServiceTime", label: "Total Time" },
          { id: "averageServiceTime", label: "Avg / Ticket" },
          { id: "effectivenessBand", label: "Review Status" },
        ],
        rows: topAgents,
        renderCell: (row, columnId) => {
          if (columnId === "totalServiceTime" || columnId === "averageServiceTime") {
            return formatTime(row[columnId]);
          }
          return row[columnId];
        },
      },
    ],
    notes: [
      `${branchSummary.reviewAgentCount} flagged agents and ${branchSummary.noWorkAgentCount} agents have no completed tickets.`,
    ],
  };
};

const BranchAgentServiceTimePerService = ({ reportIndex, data, renderConfig }) => {
  return (
    <Box>
      {data.map(({ branchName, servicesData, numServices }, branchIndex) => {
        const title = `${reportIndex || ""}.${branchIndex + 1}. ${branchName}`;
        const insights = buildAgentServiceSummary({ branchName, servicesData, numServices });
        return (
          <>
            <h2>{title}</h2>
            <Text>{numServices} services.</Text>
            <EnterpriseReportSummary
              title="Daily Agent Effectiveness Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            {servicesData.map((data, index) => {
              return (
                <AgentServiceTimePerServiceTable
                  key={index}
                  index={index}
                  serviceData={data}
                  branchIndex={branchIndex}
                  reportIndex={reportIndex}
                  branchName={branchName}
                  renderConfig={renderConfig}
                />
              );
            })}
          </>
        );
      })}
    </Box>
  );
};

export default BranchAgentServiceTimePerService;
